import { MenuItem } from '@mui/material';
import { useNavigate } from 'react-router';
import { useAuthStore } from '../../stores/auth/auth.store';
import AppMenuItem from '../ui/AppMenuItem';
import AppMenu from './AppMenu';
import { type SubmenuProps } from './submenu-props';

const TablasMenu = (props: SubmenuProps) => {
  const { permisos } = useAuthStore();
  const navigate = useNavigate();
  const goTo = (route: string) => {
    navigate(route);
    props.onClose();
  };
  const tieneAccesoGrupos = permisos.some(
    (permiso) => permiso.idModulo === 'grupos-articulos' && permiso.idPermiso === 'acceso'
  );
  const tieneAccesoAgrupaciones = permisos.some(
    (permiso) => permiso.idModulo === 'agrupaciones-articulos' && permiso.idPermiso === 'acceso'
  );
  const textoMenu =
    tieneAccesoGrupos && tieneAccesoAgrupaciones
      ? 'Grupos y Agrupaciones de Artículos'
      : tieneAccesoGrupos
        ? 'Grupos de Artículos'
        : 'Agrupaciones de Artículos';
  const rutaModulo = tieneAccesoGrupos
    ? '/grupos-agrupaciones-articulos/grupos'
    : '/grupos-agrupaciones-articulos/agrupaciones';

  return (
    <AppMenu anchorEl={props.anchorElem} open={!!props.anchorElem} onClose={props.onClose}>
      {(tieneAccesoGrupos || tieneAccesoAgrupaciones) && (
        <MenuItem onClick={() => goTo(rutaModulo)}>{textoMenu}</MenuItem>
      )}
      <AppMenuItem module="unidades" onClick={() => goTo('/unidades')}>
        Unidades
      </AppMenuItem>
      <AppMenuItem module="ubicaciones" onClick={() => goTo('/ubicaciones')}>
        Ubicaciones
      </AppMenuItem>
      <AppMenuItem module="ciudades" onClick={() => goTo('/ciudades')}>
        Ciudades
      </AppMenuItem>
      <AppMenuItem module="estados" onClick={() => goTo('/estados')}>
        Estados
      </AppMenuItem>
    </AppMenu>
  );
};

export default TablasMenu;
